import { CircularProgress } from '@mui/material';
import { FC } from 'react';

import { ReactComponent as ErrorIcon } from '../../../../assets/icons/close-filled.svg';
import { ReactComponent as CompletedIcon } from '../../../../assets/icons/completed.svg';
import {
    ErrorContentContainer,
    errorIconStyles,
    LoadingContainer,
    LoadingText,
    StatusContainer,
    StatusText,
    StyledPaper,
    successIconStyles,
    Title,
    WorkflowFeedback,
    WorkflowFeedbackText
} from './styled';

interface WorkflowStatusProps {
    workflowsPassed?: boolean;
    workflowsFeedback?: string;
    isAnalyzing?: boolean;
}

const WorkflowStatus: FC<WorkflowStatusProps> = ({
    workflowsPassed,
    workflowsFeedback,
    isAnalyzing = false
}) => {
    if (isAnalyzing) {
        return (
            <StyledPaper elevation={0}>
                <LoadingContainer>
                    <CircularProgress size={20} />
                    <LoadingText variant="body2">
                        We are analyzing your solution...
                    </LoadingText>
                </LoadingContainer>
            </StyledPaper>
        );
    }

    return (
        <StyledPaper elevation={0}>
            <Title variant="h6">
                Github Workflows status
            </Title>

            <StatusContainer>
                {workflowsPassed ? (
                    <>
                        <CompletedIcon width={20} height={20} style={successIconStyles} />
                        <StatusText variant="body2">
                            All GitHub workflows passed successfully.
                        </StatusText>
                    </>
                ) : (
                    <>
                        <ErrorIcon width={20} height={20} style={errorIconStyles} />
                        <ErrorContentContainer>
                            <StatusText variant="body2">
                                Some GitHub workflows failed, please fix them and resubmit via the extension.
                            </StatusText>
                            {workflowsFeedback && (
                                <WorkflowFeedback>
                                    <WorkflowFeedbackText variant="body2">
                                        Attached below the log error output:
                                    </WorkflowFeedbackText>
                                    <WorkflowFeedbackText variant="body2">
                                        {workflowsFeedback}
                                    </WorkflowFeedbackText>
                                </WorkflowFeedback>
                            )}
                        </ErrorContentContainer>
                    </>
                )}
            </StatusContainer>
        </StyledPaper>
    );
};

export default WorkflowStatus;
